module.exports = __webpack_public_path__ + "img/bfc.df1273b3.svg";